import permission from './permission/permission'

const install = function (Vue) {
  console.log("-----注册了指令：permission----");
  Vue.directive('permission', permission)
}
export default install
